module.exports = __webpack_public_path__ + "img/图0-1阀盖的零件图.0c74c93c.png";